import { render, staticRenderFns } from "./serviceInvalidation.vue?vue&type=template&id=2b0e6435&scoped=true&"
import script from "./serviceInvalidation.vue?vue&type=script&lang=js&"
export * from "./serviceInvalidation.vue?vue&type=script&lang=js&"
import style0 from "./serviceInvalidation.vue?vue&type=style&index=0&id=2b0e6435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e6435",
  null
  
)

export default component.exports